/* TNS-3052 – Sylora Motion-Baukasten (wiederverwendbar, siehe sylora-motion.css)
   data-sy-reveal  : einblenden, wenn sichtbar (nur unterhalb des Falzes verwenden)
   data-sy-pulse   : nach ~4 s Leerlauf 1x 2 Pulse (max. 2 Runden je Seitenaufruf)
   data-sy-sticky  : Leiste zeigen, sobald data-sy-sticky-target (z. B. Haupt-Kaufknopf) oben aus dem Bild ist
   data-sy-jump    : Link scrollt sanft zum Ziel (href="#id") und fokussiert dort den Kaufknopf */
(function () {
  if (window.SyloraMotion) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function reveals(scope) {
    var els = (scope || document).querySelectorAll('[data-sy-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !hasIO) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    document.documentElement.classList.add('sy-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
  }

  function pulses() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-sy-pulse]');
    if (!els.length) return;
    var rounds = 0, t;
    function fire() {
      if (rounds >= 2) return;
      rounds++;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight || el.closest('[aria-hidden="true"]')) return;
        el.classList.remove('is-pulsing'); void el.offsetWidth; el.classList.add('is-pulsing');
        setTimeout(function () { el.classList.remove('is-pulsing'); }, 2400);
      });
      arm();
    }
    function arm() { clearTimeout(t); if (rounds < 2) t = setTimeout(fire, 4000); }
    ['scroll', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, arm, { passive: true }); });
    arm();
  }

  function stickies() {
    document.querySelectorAll('[data-sy-sticky]').forEach(function (bar) {
      var target = document.querySelector(bar.getAttribute('data-sy-sticky-target'));
      if (!target || !hasIO) return;
      var past = false, footerIn = false;
      function set() {
        // W9: Sicherheitsnetz – nahe am Seitenende immer aus (Footer-Erkennung kann je Vorlage fehlen)
        var nearEnd = (window.scrollY + window.innerHeight) > (document.documentElement.scrollHeight - 160);
        var on = past && !footerIn && !nearEnd;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.querySelectorAll('a,button').forEach(function (x) { x.tabIndex = on ? 0 : -1; });
      }
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; set(); });
      }).observe(target);
      // TNS-3052 W7: letzter Footer der Seite (vorher griff '.footer' u. U. ein früheres Element -> Leiste verschwand mitten auf der Seite)
      var fs = document.querySelectorAll('.shopify-section-group-footer-group, footer.footer, .syf');
      var footer = fs.length ? fs[fs.length - 1] : null;
      if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { footerIn = e.isIntersecting; set(); }); }).observe(footer);
      window.addEventListener('scroll', set, { passive: true });
      set();
    });
  }

  function jumps() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('[data-sy-jump]');
      if (!a) return;
      var dest = document.querySelector(a.getAttribute('href'));
      if (!dest) return;
      ev.preventDefault();
      dest.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var btn = dest.querySelector('button[type="submit"]');
      if (btn) setTimeout(function () { btn.focus({ preventScroll: true }); }, reduce ? 0 : 500);
    });
  }

  // W3/W9 Tempo: Dauer-Animationen erst ~2,5 s nach dem Laden starten, außerhalb des Bildschirms pausieren
  function anims() {
    if (reduce) return;
    function ready() { document.documentElement.classList.add('sy-anim-ready'); }
    if (document.readyState === 'complete') setTimeout(ready, 2500);
    else window.addEventListener('load', function () { setTimeout(ready, 2500); }, { once: true });
    if (!hasIO) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('sy-offscreen', !e.isIntersecting); });
    });
    document.querySelectorAll('.sy-marquee__track,.sy-float,.sy-shine,.sy-silk--bg .sy-silk__svg').forEach(function (el) { io.observe(el); });
  }

  function init() { reveals(); pulses(); stickies(); jumps(); anims(); }
  window.SyloraMotion = { reveals: reveals };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { reveals(e.target); });
})();
